import {useRuntimeEnvironment} from '@github-ui/ssr-utils/use-runtime-environment'

import type {AhpSessionIdentifiers, ProvisioningKind, RuntimeStatus} from '../../types'

export interface EnvironmentSetupVisibilityInput {
  enabled: boolean | undefined
  runtimeStatus: RuntimeStatus
  activeAhpSession: AhpSessionIdentifiers | undefined
  provisioningKind: ProvisioningKind | undefined
}

export function useEnvironmentSetupVisibility({
  enabled,
  runtimeStatus,
  activeAhpSession,
  provisioningKind,
}: EnvironmentSetupVisibilityInput): boolean {
  const {isBrowser} = useRuntimeEnvironment()
  if (!enabled || !isBrowser) return false
  return runtimeStatus === 'provisioning' && provisioningKind === 'initial' && !activeAhpSession
}
